export const AUTH_STATES = {
  SIGNED_OUT: 'signed_out',
  AUTHENTICATING: 'authenticating',
  SIGNED_IN: 'signed_in',
  FAILED: 'failed',
};

export const VAULT_STATES = {
  UNKNOWN: 'unknown',
  CHECKING: 'checking',
  UNLOCKING: 'unlocking',
  UNLOCKED: 'unlocked',
  LOCKED: 'locked',
  MISSING: 'missing',
  RECOVERY_REQUIRED: 'recovery_required',
  ERROR: 'error',
};

export const SYNC_STATES = {
  IDLE: 'idle',
  OFFLINE: 'offline',
  SYNCING: 'syncing',
  SYNCED: 'synced',
  FAILED: 'failed',
};

export const SECURITY_PHASES = [
  {
    id: 'state_machine',
    phase: 1,
    label: 'Explicit Auth/Vault/Sync States',
    status: 'active',
  },
  {
    id: 'progressive_login',
    phase: 2,
    label: 'Progressive Sign-In UI',
    status: 'active',
  },
  {
    id: 'progressive_unlock',
    phase: 3,
    label: 'Progressive Hardware Vault Unlock',
    status: 'active',
  },
  {
    id: 'failure_handling',
    phase: 4,
    label: 'Locked vs Empty Failure Handling',
    status: 'active',
  },
  {
    id: 'recovery',
    phase: 5,
    label: 'Recovery Key Export/Restore',
    status: 'active',
  },
  {
    id: 'device_pairing',
    phase: 6,
    label: 'Encrypted Device Pairing Foundation',
    status: 'limited',
  },
  {
    id: 'local_first_crdt',
    phase: 7,
    label: 'Bucket-Backed Local-First CRDT Foundation',
    status: 'limited',
  },
];

export const VAULT_PROGRESS_COPY = {
  [VAULT_STATES.CHECKING]: {
    title: 'Authenticating',
    detail: 'Checking session and local vault state...',
  },
  [VAULT_STATES.UNLOCKING]: {
    title: 'Opening Hardware Vault',
    detail: 'Requesting biometric approval from this device...',
  },
  [SYNC_STATES.SYNCING]: {
    title: 'Syncing Encrypted State',
    detail: 'Fetching and decrypting zero-knowledge payloads...',
  },
  locking: {
    title: 'Encrypting Locally',
    detail: 'Wrapping payload with the post-quantum vault layer...',
  },
};

export function getVaultProgressCopy({ vaultState, syncState, locking }) {
  if (locking) return VAULT_PROGRESS_COPY.locking;
  if (vaultState === VAULT_STATES.UNLOCKING) return VAULT_PROGRESS_COPY[VAULT_STATES.UNLOCKING];
  if (syncState === SYNC_STATES.SYNCING) return VAULT_PROGRESS_COPY[SYNC_STATES.SYNCING];
  return VAULT_PROGRESS_COPY[VAULT_STATES.CHECKING];
}

export async function getSecurityCapabilities() {
  const hasWindow = typeof window !== 'undefined';
  const passkeySupported = Boolean(hasWindow && window.PublicKeyCredential);
  const platformAuthenticatorSupported =
    passkeySupported &&
    await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().catch(() => false);
  const webRtcSupported = Boolean(hasWindow && window.RTCPeerConnection);
  const storageSupported = Boolean(hasWindow && window.indexedDB && window.crypto?.subtle);

  return {
    passkeySupported,
    platformAuthenticatorSupported,
    webRtcSupported,
    storageSupported,
  };
}
